import { Component,EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Menu } from '../../../../menu/menu.model';
import { Router } from '@angular/router';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { normalizePath, slugify } from '@app/shared/utils';

@Component({
  selector: 'app-burger-modal-option',
  templateUrl: './burger-modal-option.component.html',
  styleUrls: ['./burger-modal-option.component.css']
})
export class BurgerModalOptionComponent implements OnInit {

  @Input() option: Menu;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  private name: string;

  constructor(private router: Router,
      private _sdkAnalyticsService:SdkAnalyticsService) { }

  ngOnInit() {
    this.name = this.getOptionName();
  }

  openMenu(): void {
    if(this.getOptionName() && this.router && this.router.url){
      this._sdkAnalyticsService.trackEvent( 'click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: 'menu-lateral-'+slugify(this.getOptionName())
      });
    }
    this.router.navigate([`/menu`, { 'menuName': this.getOptionName()}]);
    this.closeModal.emit(true);
  }

  getOptionName(): string {

    if (!this.option || !this.option.name) {
      return '';
    }
    return this.option.name.toLowerCase();
  }

  get translationKey(): string {

    if (!this.option || !this.option.translationKey) {
      return '';
    }
    return this.option.translationKey;
  }

  get optionName(): string {

    return this.name;
  }
}
